// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledSearchLoading = styled('div')(
  () => css`
    .search-loading {
      width: 100%;
      display: flex;
      flex-direction: column;
      .card {
        margin-bottom: 20px;
        position: relative;
        .header {
          .column {
            width: 50%;
            display: flex;
            align-items: center;
          }
          .column:last-child {
            justify-content: left;
          }
        }
        .body {
          background-color: #ffffff;
          line-height: 25px;
          text-align: right;
          padding: 12px 24px 24px;
          color: black;
          word-break: break-word;
          position: relative;
        }
        .footer {
          background: #ffffff;
          box-shadow: 0px 3px 6px -1px rgba(50, 50, 71, 0.05);
          border-radius: 8px;
          color: black;
          padding: 0px 20px 16px;
          justify-content: space-between;
          font-size: 0.75rem;
        }
      }
      &.resource {
        .card {
          margin-bottom: 20px;
          .header {
            min-height: 90px;
            .column:first-child {
              margin-right: 12px;
            }
            .MuiSkeleton-rounded {
              width: 50px !important;
              height: 50px !important;
              margin-left: 10px;
            }
          }
        }
      }
    }
  `
);
